const UploadIcon = () => {
  return (
    <svg
      width="92"
      height="62"
      viewBox="0 0 92 62"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M34.5 59.1195H25.875C23.021 59.1168 20.2002 58.5203 17.5998 57.3695C14.9995 56.2188 12.6791 54.5401 10.7927 52.445C8.90622 50.3499 7.49687 47.8862 6.65816 45.2175C5.81946 42.5488 5.57058 39.7361 5.92804 36.9661C6.28551 34.1962 7.24115 31.5322 8.73152 29.1512C10.2219 26.7701 12.2129 24.7264 14.5725 23.1556C16.932 21.5849 19.606 20.5231 22.4171 20.0406C25.2282 19.5582 28.1121 19.6662 30.8772 20.3575"
        stroke="#9B51E0"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.75 30.9945C28.7504 26.5382 29.8333 22.1458 31.9094 18.1792C33.9855 14.2127 36.9954 10.7855 40.691 8.18007C44.3866 5.57465 48.6622 3.8656 53.1655 3.19374C57.6687 2.52188 62.2707 2.90645 66.5922 4.31575C70.9137 5.72505 74.8311 8.11875 78.0214 11.2996C81.2118 14.4804 83.5838 18.3574 84.9421 22.6109C86.3005 26.8645 86.6061 31.3729 85.8339 35.7647C85.0618 40.1565 83.2339 44.306 80.5009 47.8711"
        stroke="#9B51E0"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M42.4275 42.9271L54.625 30.9944L66.8226 42.9271"
        stroke="#9B51E0"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M54.625 59.1195V30.9945"
        stroke="#9B51E0"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default UploadIcon;
